<template>
	<div class="event-list-item-actions">
		<Icon
			:icon-name="isExternal ? 'launch' : 'right-arrow'"
			size="md"
			aria-hidden="true"
		/>
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';

export default {
	name:       'EventListItemActions',
	components: { Icon },
	props:      {
		isExternal: {
			type:    Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.event-list-item-actions {
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--color-grey-300);
}
</style>
